import script from "./OrdersRecent.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersRecent.vue?vue&type=script&setup=true&lang=js"

import "./OrdersRecent.vue?vue&type=style&index=0&id=51bf2c97&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51bf2c97"]])

export default __exports__